import Vue from "vue";
import VueRouter from "vue-router";

// LAYOUTS
import AuthLayout from "@/layouts/AuthLayout";
import AppLayout from "@/layouts/AppLayout";

// VIEWS
import LoginView from "@/views/LoginView";
import RegisterView from "@/views/RegisterView";
import PasswordResetView from "@/views/PasswordReset";
import HomeView from "@/views/HomeView";
import ProfileView from "@/views/ProfileView";
import PasswordDetails from "@/views/PasswordDetails";
import AboutView from "@/views/AboutView";

//FIREBASE
import app from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
const auth = getAuth(app);

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "Login",
        component: LoginView,
      },
      {
        path: "/register",
        name: "Register",
        component: RegisterView,
      },
      {
        path: "/password-reset",
        name: "PasswordReset",
        component: PasswordResetView,
      },
      {
        path: "/about",
        name: "AboutView",
        component: AboutView,
      },
    ],
  },
  {
    path: "/",
    component: AppLayout,
    children: [
      {
        path: "/",
        name: "Home",
        component: HomeView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/profile",
        name: "Profile",
        component: ProfileView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/pass/:passId",
        name: "PasswordDetails",
        component: PasswordDetails,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    onAuthStateChanged(auth, (user) => {
      if (user) next();
      else next("/login");
    });
  } else {
    next();
  }
});

export default router;
